<template>
  <div class="kye-preview-file-item">
    <slot name="previewFileItem" :fileName="fileName" :url="url" :extendName="extendName">
      <div class="kye-preview-file-item-name"
        @click="download"
        :title="fileName">
        <i class="el-icon-document"></i>
        {{fileName || '无文件名'}}
      </div>
      <div
        class="kye-preview-file-item-tools"
      >
        <span class="kye-preview-file-item-tools-preview" @click="preview" v-if="canPreview">预览</span>
        <i v-if="canRemove" class="el-icon-close kye-preview-file-item-tools-close" @click="remove"></i>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    extendName: {
      type: String,
      default: ''
    },
    canDownload: {
      type: Boolean,
      default: true
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    canPreview: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  methods: {
    // 预览
    preview () {
      this.$emit('preview', {
        url: this.url,
        fileName: this.fileName,
        extendName: this.extendName,
        id: this.id
      })
    },
    // 下载
    download () {
      if (!this.canDownload) {
        return
      }
      this.$emit('download', {
        url: this.url,
        fileName: this.fileName,
        extendName: this.extendName,
        id: this.id
      })
    },
    // 删除
    remove () {
      this.$emit('remove', {
        url: this.url,
        fileName: this.fileName,
        extendName: this.extendName,
        id: this.id
      })
    },
  }
}
</script>
<style lang="less" scoped>
  .kye-preview-file-item {
    position: relative;
    font-size: 12px;
    margin-right: 12px;
    border: 1px solid var(--g-color-primary-border);
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 8px 0 8px;
    min-width: 200px;
    height: 28px;
    &:hover {
      background-color: rgba(149, 113, 233, 0.1);
    }
    &-name {
      padding: 0 20px 0 0px;
      color: var(--g-color-primary);
      display: inline-block;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: color 0.3s;
      white-space: nowrap;
      cursor: pointer;
    }
    &-tools {
      color: var(--g-color-primary);
      // min-width: 42px;
      display: flex;
      align-items: baseline;
      &-preview,&-close {
        cursor: pointer;
      }
      &-close {
        margin-left: 6px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-preview/component/file-item.vue